module.exports = __webpack_public_path__ + "img/synapse-homepage2.2baf5c6b.png";